export { I18nLink as default, I18nLink as Link } from "@/i18n/routing";
